import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Stack } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

interface AccordionSectionProps {
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
  title: string;
  children: React.ReactNode;
  count?: number;
}

export const AccordionSection = ({ expanded, onChange, title, children, count }: AccordionSectionProps) => (
  <Accordion
    square
    expanded={expanded}
    onChange={onChange}
    sx={{
      background: 'transparent',
      // leave accordion separator visible when expanded
      '&.Mui-expanded::before': { opacity: 1 },
      '&.Mui-expanded': { m: 0 },
      // ensure consistent border separator between accordion sections
      '&:not(:last-child)': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      },
    }}
  >
    <AccordionSummary
      sx={{
        px: 0,
        // default expanded = 68, collapsed = 48, caused jumping
        minHeight: '68px',
        '&.Mui-expanded': { minHeight: '68px' },
        // reset margins, spacing between accordion items achived via min-height
        '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': { m: 0 },
      }}
    >
      <Stack direction="row" alignItems="center" width={1}>
        {expanded ? <ExpandLess sx={{ mr: 2 }} /> : <ExpandMore sx={{ mr: 2 }} />}
        <Typography variant="subtitle1" flex={1}>
          {title}
          {count !== undefined && count > 0 && (
            <Typography
              variant="subtitle1"
              component="span"
              sx={{
                ml: 1,
                color: 'primary.main',
                fontWeight: 'bold',
              }}
            >
              ({count})
            </Typography>
          )}
        </Typography>
      </Stack>
    </AccordionSummary>
    <AccordionDetails sx={{ pb: 5 }}>{children}</AccordionDetails>
  </Accordion>
);
